module.exports = __webpack_public_path__ + "6a7e3df0d17d3d8eb74a321562448c62.svg";